import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { SetupProvider } from './context/SetupContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AccountPage from './pages/AccountPage';
import BrandingPage from './pages/BrandingPage';
import ReservationTypesPage from './pages/ReservationTypesPage';
import SettingsPage from './pages/SettingsPage';
import CustomersPage from './pages/CustomersPage';
import ClientAccessPage from './pages/ClientAccessPage';
import SearchPage from './pages/SearchPage';
import SuperAdminPage from './pages/SuperAdminPage';
import ContactPage from './pages/ContactPage';

function GuestRoute({ children }) {
  const { isAuthenticated, isSuperAdmin } = useAuth();
  if (!isAuthenticated) return children;
  return <Navigate to={isSuperAdmin ? '/superadmin' : '/'} replace />;
}

function SuperAdminRoute({ children }) {
  const { isAuthenticated, isSuperAdmin } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isSuperAdmin) return <Navigate to="/" replace />;
  return children;
}

function AccountRoute({ children }) {
  const { isSuperAdmin } = useAuth();
  if (isSuperAdmin) return <Navigate to="/superadmin" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <SetupProvider>
      <ToastContainer position="top-center" rtl autoClose={3000} />
      <Routes>
        <Route
          path="/login"
          element={
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          }
        />
        <Route element={<Layout />}>
          <Route index element={<AccountRoute><DashboardPage /></AccountRoute>} />
          <Route path="account" element={<AccountRoute><AccountPage /></AccountRoute>} />
          <Route path="branding" element={<AccountRoute><BrandingPage /></AccountRoute>} />
          <Route path="reservation-types" element={<AccountRoute><ReservationTypesPage /></AccountRoute>} />
          <Route path="settings" element={<AccountRoute><SettingsPage /></AccountRoute>} />
          <Route path="customers" element={<AccountRoute><CustomersPage /></AccountRoute>} />
          <Route path="client-access" element={<AccountRoute><ClientAccessPage /></AccountRoute>} />
          <Route path="search" element={<AccountRoute><SearchPage /></AccountRoute>} />
          <Route path="contact" element={<ContactPage />} />
          <Route
            path="superadmin"
            element={
              <SuperAdminRoute>
                <SuperAdminPage />
              </SuperAdminRoute>
            }
          />
          <Route
            path="superadmin/:tab"
            element={
              <SuperAdminRoute>
                <SuperAdminPage />
              </SuperAdminRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </SetupProvider>
    </AuthProvider>
  );
}
